import { render, staticRenderFns } from "./DetailPembayaran.vue?vue&type=template&id=bb679c4a&"
import script from "./DetailPembayaran.vue?vue&type=script&lang=js&"
export * from "./DetailPembayaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports